import { render, staticRenderFns } from "./nutrition.vue?vue&type=template&id=be99b6a0&scoped=true&"
import script from "./nutrition.vue?vue&type=script&lang=js&"
export * from "./nutrition.vue?vue&type=script&lang=js&"
import style0 from "./nutrition.vue?vue&type=style&index=0&id=be99b6a0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be99b6a0",
  null
  
)

component.options.__file = "nutrition.vue"
export default component.exports